'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

export interface SectionTab {
  label: string;
  href: string;
}

interface SectionTabsProps {
  tabs: SectionTab[];
  className?: string;
  'data-section-tabs'?: string;
}

export default function SectionTabs({
  tabs,
  className,
  'data-section-tabs': dataSectionTabs,
}: SectionTabsProps) {
  const pathname = usePathname();

  return (
    <div
      className={`border-stroke-white flex items-center justify-center border-b bg-white py-3 ${className || ''}`}
      data-section-tabs={dataSectionTabs}
    >
      {tabs.map((tab, idx) => {
        const isActive = pathname.startsWith(tab.href);
        return (
          <div key={tab.href} className="flex items-center">
            <Link
              key={tab.href}
              href={tab.href}
              className={`typo-18 rounded-[20px] px-4 py-2 font-semibold transition ${
                isActive
                  ? 'bg-main-yellow text-level-2'
                  : 'text-level-5 hover:bg-bg-graylight'
              }`}
            >
              {tab.label}
            </Link>
            {idx < tabs.length - 1 && (
              <span className="mx-2 text-gray-300" aria-hidden="true">
                ·
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
